module.exports = __webpack_public_path__ + "static/img/wechat_customer_service.720cf491.jpg";